import i18n from "../i18n";

const STORAGE_KEY = "retailmaps:regional-preferences";
const LANDING_LANGUAGE_KEY = "retailmaps:landing-language-preference";
export const REGIONAL_PREFERENCES_EVENT = "regionalPreferencesUpdated";

const currencyByRegion = {
  NL: "EUR",
  BE: "EUR",
  FR: "EUR",
  DE: "EUR",
  ES: "EUR",
  IT: "EUR",
  GB: "GBP",
  US: "USD",
  CA: "CAD",
  AU: "AUD",
  CH: "CHF",
  SE: "SEK",
  NO: "NOK",
  DK: "DKK",
  PL: "PLN",
  CZ: "CZK",
  AE: "AED",
};

const unitsByRegion = {
  US: "imperial",
  GB: "imperial",
  LR: "imperial",
  MM: "imperial",
};

const supportedLanguages = ["en", "nl", "de", "fr", "es", "it"];

export const rememberLandingLanguagePreference = (language) => {
  const normalized = String(language || "").split("-")[0].toLowerCase();
  if (!supportedLanguages.includes(normalized)) return;
  try {
    localStorage.setItem(LANDING_LANGUAGE_KEY, normalized);
  } catch {
    // De actieve i18n-taal blijft ook zonder localStorage bruikbaar.
  }
};

export const readLandingLanguagePreference = () => {
  try {
    const normalized = String(localStorage.getItem(LANDING_LANGUAGE_KEY) || "")
      .split("-")[0]
      .toLowerCase();
    return supportedLanguages.includes(normalized) ? normalized : "";
  } catch {
    return "";
  }
};

export const clearLandingLanguagePreference = () => {
  try {
    localStorage.removeItem(LANDING_LANGUAGE_KEY);
  } catch {
    // ignore
  }
};

const getBrowserLanguage = () => {
  const language = navigator.language || "nl-NL";
  const short = language.split("-")[0];
  return supportedLanguages.includes(short) ? short : "en";
};

export const getBrowserRegion = () => {
  const locale = navigator.language || "nl-NL";
  const parts = locale.split("-");
  return (parts[1] || "NL").toUpperCase();
};

export const detectRegionalPreferences = () => {
  const region = getBrowserRegion();

  return {
    detectedLanguage: getBrowserLanguage(),
    detectedCurrency: currencyByRegion[region] || "EUR",
    detectedUnits: unitsByRegion[region] || "metric",
    detectedRegion: region,
  };
};

export const saveRegionalPreferencesLocally = (preferences) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences));
    window.dispatchEvent(
      new CustomEvent(REGIONAL_PREFERENCES_EVENT, { detail: preferences })
    );
  } catch {
    // ignore
  }
};

export const readRegionalPreferencesLocally = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const resolveRegionalPreferences = (storedPreferences) => {
  const detected = detectRegionalPreferences();
  const preferences = storedPreferences || readRegionalPreferencesLocally() || {
    language: "auto",
    currency: "auto",
    units: "auto",
  };

  return {
    ...preferences,
    resolvedLanguage:
      preferences.language === "auto"
        ? detected.detectedLanguage
        : preferences.language,
    resolvedCurrency:
      preferences.currency === "auto"
        ? detected.detectedCurrency
        : preferences.currency,
    resolvedUnits:
      preferences.units === "auto"
        ? detected.detectedUnits
        : preferences.units,
    detectedRegion: detected.detectedRegion,
  };
};

export const applyLanguagePreference = async (preferences) => {
  const resolved = resolveRegionalPreferences(preferences);

  try {
    await i18n.changeLanguage(resolved.resolvedLanguage);
  } catch (err) {
    console.warn("⚠️ taalwissel mislukt:", err);
  }

  saveRegionalPreferencesLocally({
    language: preferences?.language || "auto",
    currency: preferences?.currency || "auto",
    units: preferences?.units || "auto",
  });

  return resolved;
};
